import { trySync } from "@otto-ec/assets-core-utils/nano-effect";
import { logger } from "@otto-ec/global-resources/debug";

const log = logger("oc.performance.init");

export const initComplete = trySync(
  (p = window.performance) => {
    p.mark("otto-components-init-end");
    p.measure("otto-components-init", "otto-components-init-start", "otto-components-init-end");
    /*                                          */
    /*                                        */
    /*                                       */
  },
  (e) => {
    log.info("Failed to mark oc init", e);
    return e;
  },
);
